export const RAW_DATA_GET_DEVICE_READING_OPEN_MODAL = "RAW_DATA_GET_DEVICE_READING_OPEN_MODAL";
export const RAW_DATA_GET_DEVICE_READING_REQUEST = "RAW_DATA_GET_DEVICE_READING_REQUEST";
export const RAW_DATA_GET_DEVICE_READING_RESULT = "RAW_DATA_GET_DEVICE_READING_RESULT";